module.exports = __webpack_public_path__ + "static/baker.a8a30c5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/baker.png
// module id = 2177
// module chunks = 61762850755587